import Error from 'assets/amico.svg';
import { 
  Container,
  Wrapper,
  Title,
  Message,
  Status,
  Image,
  StyledButton,
} from './styles';

export const ErrorScreen = ({ title, message, status }: { title: string, message: string, status: number }) => {
  const redirectToHome = () => {
    window.location.href = '/';
  }

  return (
    <Container>
      <Wrapper>
        <Title>{title}</Title>

        <Message>{message}</Message>

        <Status>#{status}</Status>

        <Image src={Error} />
        
        <StyledButton onClick={() => redirectToHome()}>Ir para início</StyledButton>
      </Wrapper>
    </Container>
  )
}